
import React, { useState } from "react";
import { EnvelopeIcon, PhoneIcon, MapPinIcon } from "@heroicons/react/24/outline";

export default function Contact() {
  const [form, setForm] = useState({ name: "", email: "", message: "" });
  const handleChange = (e) =>
    setForm({ ...form, [e.target.name]: e.target.value });
  const handleSubmit = (e) => {
    e.preventDefault();
    // handle form submission (e.g., via email or API)
    alert("Message sent!");
    setForm({ name: "", email: "", message: "" });
  };

  return (
    <section className="bg-gray-50 py-16">
      <div className="container mx-auto px-4 md:flex md:items-center md:space-x-12">
        {/* Illustrative Image */}
        <div className="md:w-1/2 mb-8 md:mb-0">
          <img
            src="/contact-image.jpg"
            alt="Contact Us"
            className="w-full rounded-lg shadow-lg"
          />
        </div>

        {/* Contact Form */}
        <div className="md:w-1/2 bg-white rounded-lg shadow-lg p-8">
          <h3 className="text-2xl font-bold mb-6 text-[#D7631F]">
            Get in Touch
          </h3>
          <form onSubmit={handleSubmit} className="space-y-4">
            <div>
              <label className="block text-gray-700 mb-2" htmlFor="name">
                Name
              </label>
              <input
                type="text"
                id="name"
                name="name"
                value={form.name}
                onChange={handleChange}
                placeholder="Your Name"
                className="w-full p-3 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-[#D7631F]"
                required
              />
            </div>

            <div>
              <label className="block text-gray-700 mb-2" htmlFor="email">
                Email
              </label>
              <input
                type="email"
                id="email"
                name="email"
                value={form.email}
                onChange={handleChange}
                placeholder="Your Email"
                className="w-full p-3 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-[#D7631F]"
                required
              />
            </div>

            <div>
              <label className="block text-gray-700 mb-2" htmlFor="message">
                Message
              </label>
              <textarea
                id="message"
                name="message"
                value={form.message}
                onChange={handleChange}
                placeholder="Your Message"
                rows="5"
                className="w-full p-3 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-[#D7631F]"
                required
              />
            </div>

            <button
              type="submit"
              className="w-full bg-[#D7631F] text-white py-3 rounded hover:bg-[#BF5C1A] transition"
            >
              Send Message
            </button>
          </form>

          {/* Contact Details */}
          <div className="mt-8 text-gray-600">
            <p className="flex items-center mb-3">
         <MapPinIcon className="w-5 h-5 mr-2 text-[#D7631F]" />
              6352 LOTUS STREET, EASTVALE, CA 92880, US</p>
            <p className="flex items-center mb-3">
             <PhoneIcon className="w-5 h-5 mr-2 text-[#D7631F]" />
              +1 (323) 985-8774</p>
            <p className="flex items-center">
              <EnvelopeIcon className="w-5 h-5 mr-2 text-[#D7631F]" />
              info@futureyx.com
            </p>
          </div>
        </div>
      </div>
    </section>);
}
